import SEO from "@/components/SEO";
import { FAQ } from "@/lib/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQPage() {
  return (
    <>
      <SEO title="FAQ — Tech Alpha SSL" description="Answers to common questions about SSL, security, hosting, and support." canonical="https://techalphassl.com/faq" />
      <section className="pt-20 pb-10">
        <div className="container-page max-w-3xl">
          <span className="eyebrow">FAQ</span>
          <h1 className="mt-4 text-4xl md:text-6xl font-semibold tracking-tighter">Common questions.</h1>
          <p className="mt-4 text-lg text-muted-foreground">Straight answers about how we work.</p>
        </div>
      </section>
      <section className="pb-20">
        <div className="container-page max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-base md:text-lg font-medium tracking-tight">{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
}
